/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";

    import MarketPricingEntityEnum = Meevo.Model.MarketPricingEntityEnum;

    /**
     * History Section
     */
    export class HistorySection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.DataMaintenance> {
        public disableCrud: boolean = true; // hide bottom buttons
        public disableAuditHistory = true;
        public filter: any = {
            criteria: {},
            pageNumber: 0,
            itemsPerPage: 100,
        };
        public historyList: Array<any>;

        private marketPricingEntityEnum = [
            {
                id: null,
                displayName: 'LABEL_ALL'
            },
            {
                id: MarketPricingEntityEnum.Service,
                displayName: 'LABEL_SERVICE'
            },
            {
                id: MarketPricingEntityEnum.Product,
                displayName: 'LABEL_PRODUCT'
            },
            {
                id: MarketPricingEntityEnum.Package,
                displayName: 'LABEL_PACKAGE'
            },
            {
                id: MarketPricingEntityEnum.Membership,
                displayName: 'LABEL_MEMBERSHIP'
            },
            {
                id: MarketPricingEntityEnum.MemberBenefitTemplate,
                displayName: 'LABEL_MEMBER_BENEFIT_TEMPLATE'
            },
            {
                id: MarketPricingEntityEnum.Location,
                displayName: 'LABEL_LOCATION_ACTIVITY'
            },
            /*
            {
                id: MarketPricingEntityEnum.PriceGroup,
                displayName: 'LABEL_PRICEGROUP'
            },
            */
        ];
        private usageTrackingLogFn: (verbEnum: Meevo.Model.VerbEnum, payload?) => void;

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );

            this.usageTrackingLogFn = params.usageTrackingLogFn;
        }


        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {}

        /**
         * When tab is activated
         * */
        public selected(): void {
            this.applyFilter();
        }

        applyFilter(): void {
            let urlLink: string = '';

            if (this.identityService.inCentralOfficeMode()) {
                urlLink = `api/${this.params.baseEndpoint}/${this.model.id}/History/List`
            } else {
                urlLink = `api/${this.params.baseEndpoint}/History/List`
            }


            if (this.filter.criteria.location) {
                this.filter.criteria.locationId = this.filter.criteria.location.id;
            }

            if (this.filter.criteria.dateTill) {
                this.filter.criteria.dateTill.setHours(23, 59, 59);
            }

            this.params.dataService.customMethodData(urlLink, 'POST', this.filter).then((resp) => {
                this.historyList = resp.data;

                let re = /;/g;
                this.historyList.forEach((el) => {
                    if (el.entityType === MarketPricingEntityEnum.Service) {
                        el.actionDescription = el.actionDescription.replace(re, '\<br\>');
                    }
                })
            }).finally(() => {
                this.usageTrackingLogFn(Meevo.Model.VerbEnum.SearchButtonClicked);
            });
        }
    }
}
